// SPV Pool v1.0 PR 9 — TanStack Query hooks for the cross-pool dashboard.

import { useQuery } from "@tanstack/react-query";
import { capitalMarketsDashboardApi } from "@/api/capitalMarketsDashboard";

export const dashboardKeys = {
  all: ["cm-dashboard"] as const,
  topKpis: () => [...dashboardKeys.all, "top-kpis"] as const,
  poolsInFlight: () => [...dashboardKeys.all, "pools-in-flight"] as const,
  upcomingEvents: (daysAhead: number) =>
    [...dashboardKeys.all, "upcoming-events", daysAhead] as const,
  aggregateConcentration: () =>
    [...dashboardKeys.all, "aggregate-concentration"] as const,
};

export function useTopKpis() {
  return useQuery({
    queryKey: dashboardKeys.topKpis(),
    queryFn: () => capitalMarketsDashboardApi.topKpis(),
  });
}

export function usePoolsInFlight() {
  return useQuery({
    queryKey: dashboardKeys.poolsInFlight(),
    queryFn: () => capitalMarketsDashboardApi.poolsInFlight(),
  });
}

export function useUpcomingEvents(daysAhead: number) {
  return useQuery({
    queryKey: dashboardKeys.upcomingEvents(daysAhead),
    queryFn: () => capitalMarketsDashboardApi.upcomingEvents(daysAhead),
  });
}

export function useAggregateConcentration() {
  return useQuery({
    queryKey: dashboardKeys.aggregateConcentration(),
    queryFn: () => capitalMarketsDashboardApi.aggregateConcentration(),
  });
}
